import React, { ReactElement } from 'react';

// Components

import UniversalInput from '@lib/wrappers/UniversalInput';

// Constants

import { INPUT_TYPES } from '@constants/inputs/inputTypes';
import { VALIDATION_TYPES } from '@constants/inputs/validationTypes';

// Types

import { SsapData } from '../../../SsapTypes';

interface IMedicaidContactAttestation {
    actions: {
        onFieldChange_data: Function
    },
    data: SsapData,
    formName: string
}

const MedicaidContactAttestation = (props: IMedicaidContactAttestation): ReactElement => {
    const {
        actions: {
            onFieldChange_data
        },
        data,
        data: {
            legalAttestations: {
                medicaidContactAgreementIndicator
            }
        },
        formName
    } = props;

    return (
        <UniversalInput
            label = { {
                text: 'ssap.input.label.medicaid_contact_agreement',
                labelClass: [ 'required-true' ]
            } }
            inputData = { {
                isInputRequired: true,
                classes: [ 'disp-styl' ],
                type: INPUT_TYPES.CHECKBOX,
                name: 'medicaidContactAgreementIndicator',
                checked: medicaidContactAgreementIndicator,
                value: medicaidContactAgreementIndicator,
                validationType: VALIDATION_TYPES.CHECKED,
                currentData: data,
                fields: [ 'legalAttestations' ]
            }}
            errorClasses = { [ 'margin-l-0' ] }
            inputActions = { {
                onFieldChange: onFieldChange_data
            } }
            underFormControl
            parentForm = { { name: formName } }
        />
    );
};

export default  MedicaidContactAttestation;